import { useState } from 'react';
import api from '../api/client';

/**
 * Постоянная ссылка на конференцию и правка URL преподавателем.
 */
export default function StudentTelemostCell({ studentId, telemostUrl, onUpdated }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const url = (telemostUrl || '').trim();

  function startEdit(e) {
    e.stopPropagation();
    setDraft(url);
    setError('');
    setEditing(true);
  }

  function cancel(e) {
    e.stopPropagation();
    setEditing(false);
    setError('');
  }

  async function save(e) {
    e.preventDefault();
    e.stopPropagation();
    setSaving(true);
    setError('');
    try {
      const res = await api.patch(`/teacher/students/${studentId}/telemost/`, {
        telemost_url: draft.trim(),
      });
      onUpdated?.(res.data.telemost_url ?? '');
      setEditing(false);
    } catch (err) {
      const msg = err.response?.data?.telemost_url;
      setError(
        Array.isArray(msg)
          ? msg[0]
          : (typeof msg === 'string' ? msg : 'Не удалось сохранить ссылку.'),
      );
    } finally {
      setSaving(false);
    }
  }

  if (editing) {
    return (
      <form className="student-messenger-edit" onClick={(e) => e.stopPropagation()} onSubmit={save}>
        <input
          type="url"
          className="form-input"
          autoFocus
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          placeholder="https://telemost.yandex.ru/j/…"
          aria-label="Ссылка на Телемост"
        />
        {error && <div className="student-messenger-error">{error}</div>}
        <div className="student-messenger-edit-actions">
          <button type="submit" className="btn btn-xs btn-primary" disabled={saving}>
            {saving ? '…' : 'Сохранить'}
          </button>
          <button type="button" className="btn btn-xs btn-outline" onClick={cancel} disabled={saving}>
            Отмена
          </button>
        </div>
      </form>
    );
  }

  return (
    <div className="student-messenger" onClick={(e) => e.stopPropagation()}>
      {url ? (
        <a
          className="student-messenger-open"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          title={url}
        >
          <i className="fa-solid fa-video" aria-hidden />
          Телемост
        </a>
      ) : (
        <span className="text-secondary student-messenger-empty">нет ссылки</span>
      )}
      <button
        type="button"
        className="btn btn-xs btn-outline student-messenger-edit-btn"
        onClick={startEdit}
        title="Изменить ссылку на конференцию"
        aria-label="Изменить ссылку на конференцию"
      >
        <i className="fa-solid fa-pencil" aria-hidden />
      </button>
    </div>
  );
}
